import { bl_b2b_payment_request_stmt_import_file_helper_RowClass } from '../../../dbschema/bl_b2b_payment_request_stmt_import_file_helper.model';
import { BaseContainerModel } from '../../base-container.model';

export class PaymentStatementImportFileHelperContainerModel extends BaseContainerModel {
    bl_b2b_payment_request_stmt_import_file_helper: bl_b2b_payment_request_stmt_import_file_helper_RowClass = new bl_b2b_payment_request_stmt_import_file_helper_RowClass();
}